import React, { useEffect, useState } from 'react';
import * as app_consts from "../../utils/app_consts";
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { Button, Col, Icon } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { TENANT_UPDATE_STOCK_TAKE_PRODUCTS_API } from '../../api/api_data';
import { fail_tenant_update_stock_take_products, loading_tenant_update_stock_take_products, reset_tenant_update_stock_take_products, success_tenant_update_stock_take_products } from '../../reducers/auth_tenant/tenant_update_stock_take_products_Slice';
import { TENANT_UPDATE_STOCK_TAKE_PRODUCTS_ERROR_MSG, TENANT_UPDATE_STOCK_TAKE_PRODUCTS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';

const initialState = { reference_number: "", reason: "" };

const UpdateStockTakeProducts = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [formData, setFormData] = useState(initialState);

 useEffect(() => {
  setError("");
  setPageData(data);
  setOpen(isOpen);
  if (isOpen) 
  {
   setFormData({ ...formData, reference_number: data?.reference_number, reason: "" });
  }
 }, [data, isOpen]);

 const handleChange = (e) => {
  setFormData({ ...formData, reason: e.target.value });
 };

 const confirmClick = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_update_stock_take_products, success_tenant_update_stock_take_products, fail_tenant_update_stock_take_products, TENANT_UPDATE_STOCK_TAKE_PRODUCTS_ERROR_MSG, TENANT_UPDATE_STOCK_TAKE_PRODUCTS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_STOCK_TAKE_PRODUCTS_API}`, formData));
 };

 // Listener
 const tenant_update_stock_take_products_listener = useSelector((state) => state.tenant_update_stock_take_products.tenant_update_stock_take_products);

 useEffect(() => {
  if (tenant_update_stock_take_products_listener.status !== app_consts.IDLE)
  {
   if (tenant_update_stock_take_products_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (tenant_update_stock_take_products_listener.status === app_consts.FAIL)
    {
     setError(tenant_update_stock_take_products_listener.message);
     messageToast(tenant_update_stock_take_products_listener.message, app_consts.FAIL);
    } else if (tenant_update_stock_take_products_listener.status === app_consts.SUCCESS)
    {
     successFunction();
     messageToast(TENANT_UPDATE_STOCK_TAKE_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
    }
    dispatch(reset_tenant_update_stock_take_products());
   }
  }
 }, [tenant_update_stock_take_products_listener]);

 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Update Stock Take Products</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <p>Are you sure that you want to Update Stock Take Products in Stock Take {page_data?.reference_number}?</p>
      <TextInput
       colSize={12}
       parentClassName="mt-2"
       label="Reason"
       type="text"
       id_val="input"
       handleChange={handleChange}
       name="input"
       required
      />
      <Col xl="12" className="d-flex justify-between mt-4 mr-2">
       <Button onClick={() => { setOpen(!isOpen); }} className="btn-secondary">No</Button>
       <Button onClick={confirmClick} disabled={loading || !(formData?.reason)} className=" btn-danger ">
        {loading ? <Spinner size="sm" /> : "YES"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default UpdateStockTakeProducts;